import { Col, Row } from "react-bootstrap";
import { useIntl } from "react-intl";
import { SimpleFormSelect, SimpleFormSelectOption } from "../form/SimpleFormSelect";
import { useField } from "formik";
import { useEffect, useState } from "react";
import { Site } from "src/app/types/Site";
import { OrderType } from "src/app/types/planning";

export interface IRequestPlanningForm {
    planningOptions?: { options: IPlanningOptions[]; loading: boolean };
    handlerChangePlanning?(planningId: number): void;
}

export interface IPlanningOptions extends SimpleFormSelectOption {
    moneySite: Site;
    months: number;
    orderType: OrderType | null;
}
const RequestPlanningForm = (props: IRequestPlanningForm) => {
    const { planningOptions = { options: [], loading: false }, handlerChangePlanning = () => {} } =
        props;
    const { formatMessage } = useIntl();
    const [planningId] = useField("planningId");

    const [currentOption, setCurrentOption] = useState<IPlanningOptions>();
    const handleResume = (
        type: "filling" | "ranking" | "netlinking" | "discover" | "lead" | "boost" | "months"
    ) => {
        if (!currentOption) return;
        switch (type) {
            case "months": {
                return { months: currentOption?.months };
            }
            case "filling":
                return {
                    months: currentOption?.months,
                    filling: currentOption?.moneySite?.content?.filling || 0,
                    get fillingOrder() {
                        return this.filling * this.months;
                    },
                };
            case "ranking":
                return {
                    months: currentOption?.months,
                    ranking: currentOption?.moneySite?.content?.ranking || 0,
                    get rankingOrder() {
                        return this.ranking * this.months;
                    },
                };
            case "discover":
                return {
                    months: currentOption?.months,
                    discover: currentOption?.moneySite?.content?.discover || 0,
                    get discoverOrder() {
                        return this.discover * this.months;
                    },
                };
            case "boost":
                return {
                    months: currentOption?.months,
                    boost: currentOption?.moneySite?.content?.boost || 0,
                    get boostOrder() {
                        return this.boost * this.months;
                    },
                };
            case "lead":
                return {
                    months: currentOption?.months,
                    lead: currentOption?.moneySite?.content?.lead || 0,
                    get leadOrder() {
                        return this.lead * this.months;
                    },
                };
            case "netlinking":
                return {
                    months: currentOption?.months,
                    nlT1: currentOption?.moneySite?.content?.netlinking || 0,
                    nlT2: 2,

                    get nlT1Order() {
                        return this.nlT1 * this.months;
                    },
                    get nlT2Order() {
                        return this.nlT1Order * this.nlT2;
                    },
                };
        }
    };
    useEffect(() => {
        if (planningId?.value !== currentOption?.moneySite?.id) {
            const option = planningOptions?.options?.find((el) => el.value === planningId.value);
            setCurrentOption(option);
            handlerChangePlanning(planningId.value);
        }
    }, [planningId.value]);

    return (
        <Row>
            <Row>
                <Col sm={8}>
                    <SimpleFormSelect
                        name="planningId"
                        label={formatMessage({ id: "common.stepper.choseSite" })}
                        values={planningOptions.options}
                        isLoading={planningOptions.loading}
                        cssClass={["stepperInput"]}
                    />
                </Col>
            </Row>
            {planningId?.value && currentOption?.months && (
                <div>
                    {((!!currentOption?.orderType?.filling ||
                        !!currentOption?.orderType?.ranking ||
                        !!currentOption?.orderType?.boost ||
                        !!currentOption?.orderType?.discover ||
                        !!currentOption?.orderType?.lead ||
                        !!currentOption?.orderType?.netlinking) && (
                        <p className="mt-5">
                            {formatMessage(
                                { id: "planning.orderResume.months" },
                                { ...handleResume("months") }
                            )}
                        </p>
                    )) || (
                        <p className="mt-5">
                            {formatMessage({ id: "planning.orderResume.noPlanning" })}
                        </p>
                    )}
                    <ul>
                        {!!currentOption?.orderType?.filling && (
                            <li>
                                {formatMessage(
                                    { id: "planning.orderResume.filling" },
                                    { ...handleResume("filling") }
                                )}
                            </li>
                        )}

                        {!!currentOption?.orderType?.ranking && (
                            <li>
                                {formatMessage(
                                    { id: "planning.orderResume.ranking" },
                                    { ...handleResume("ranking") }
                                )}
                            </li>
                        )}

                        {!!currentOption?.orderType?.lead && (
                            <li>
                                {formatMessage(
                                    { id: "planning.orderResume.lead" },
                                    { ...handleResume("lead") }
                                )}
                            </li>
                        )}

                        {!!currentOption?.orderType?.discover && (
                            <li>
                                {formatMessage(
                                    { id: "planning.orderResume.discover" },
                                    { ...handleResume("discover") }
                                )}
                            </li>
                        )}

                        {!!currentOption?.orderType?.boost && (
                            <li>
                                {formatMessage(
                                    { id: "planning.orderResume.boost" },
                                    { ...handleResume("boost") }
                                )}
                            </li>
                        )}

                        {!!currentOption?.orderType?.netlinking && (
                            <li>
                                {formatMessage(
                                    { id: "planning.orderResume.netlinking" },
                                    { ...handleResume("netlinking") }
                                )}
                            </li>
                        )}
                    </ul>
                </div>
            )}
        </Row>
    );
};

export default RequestPlanningForm;
